<template>
  <section class="HuaXing">
    <div class="HuaXingContainer">
      <template v-for="(item, index) in info">
        <div class="containerBox" :key="index">
          <div class="container" @click="showDialog(item)">
            <div class="imgBox">
              <img class="img" :src="item.mp_logo_pic[0].url" alt="" />
              <div class="inform">进一步了解</div>
            </div>
            <div class="colorCode">{{ item.color_code }}</div>
            <div class="colorName">{{ item.color_name }}</div>
          </div>
        </div>
      </template>
    </div>
    <div v-if="showBtn" :class="['toomore', {'disabled': isloading} ]" @click="next">
      <span v-if="isloading"><i class="el-icon-loading"></i>加载中</span>
      <span v-else>更多花型</span>
    </div>
    <el-dialog
      :visible.sync="showPopup"
      custom-class="dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-box">
        <div class="box" v-if="colorData.mp_content">
          <img class="closebtn" src="@/assets/serve/designer/close.png" @click="closeDialog">
          <img v-if="mp_title_pic[0]" class="tit-pic" :src="mp_title_pic[0].url" alt="">
          <div v-else class="tit-pic"></div>
          <img class="link" v-if="colorData.vr_link" @click="skip(colorData.vr_link)" src="@/assets/family/link.png" alt="">
          <div class="info">
            <div class="info-name">{{colorData.color_name}}</div>
            <div class="line-s"></div>
            <div class="line-l"></div>
            <div class="desc">{{colorData.color_desc}}</div>
          </div>
          <div v-html="html" class="content">
          </div>
        </div>
        <div class="box" v-else>
          <img class="closebtn" src="@/assets/serve/designer/close.png" @click="closeDialog">
          <img v-if="mp_title_pic[0]" class="tit-pic" :src="mp_title_pic[0].url" alt="">
        </div>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { getColors } from '@/api/product.js'
import axios from '@/util/request'
export default {
  name: "HuaXingContainer",
  components: {},
  props: {
    info: {
      type: Array
    },
    showBtn: {
      type: Boolean
    },
    isloading: {
      type: Boolean
    }
  },
  data() {
    return {
      showPopup: false,
      dialogData: '',
      colorData: {},
      mp_title_pic: '',
      html: ''
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    next() {
      this.$emit('next')
    },
    showDialog(data) {
      if (data) {
        getColors({
          id: data.id
        }).then(res => {
          if (res.result === 1) {
            this.colorData = res.data
            if (res.data.mp_content) {
              this.mp_title_pic = JSON.parse(this.colorData.mp_title_pic)
              this.getHtml()
            } else {
              this.mp_title_pic = JSON.parse(this.colorData.mp_logo_pic)
              console.log(res.data)
            }
            this.showPopup = true
          }
        })
        setTimeout(() => {
          document.querySelectorAll('oembed[url]').forEach(element => {
            const videoLable = document.createElement('video')
            videoLable.setAttribute('src', element.getAttribute('url'))
            videoLable.setAttribute('controls', 'controls')
            videoLable.setAttribute('playsinline', '')
            videoLable.setAttribute('style', ' width: 100%;height: 100%; ')
            element.appendChild(videoLable)
          })
        }, 500)
      }
    },

    getHtml() {
      axios.get(this.colorData.mp_content)
        .then(res => {
          this.html = res
        })
    },

    skip(link) {
      window.open(link)
    },

    closeDialog() {
      this.showPopup = false
    }
  },
};
</script>
<style lang='less' scoped>
.HuaXing {
  width: 1498px;
  margin: 0 auto 100px auto;
  .HuaXingContainer {
    width: 1498px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    .containerBox {
      width: 352px;
      height: 447px;
      position: relative;
      margin: 37px 26.5px 37px 0;
      .container {
        height: 410px;
        text-align: left;
        padding: 37px 17px 20px 17px;
        background: #ffffff;
        box-shadow: 0px 0px 11px 1px rgba(0, 0, 0, 0.23);
        border-radius: 24px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -223.5px;
        margin-left: -176px;
        z-index: 2;
        .imgBox {
          width: 311px;
          height: 311px;
          position: relative;
          .img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .inform {
            width: 224px;
            height: 61px;
            font-size: 32px;
            font-weight: 400;
            color: #595757;
            line-height: 61px;
            text-align: center;
            background: #ffffff;
            border-radius: 30px;
            position: absolute;
            z-index: 3;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            opacity: 0;
          }
        }
        .colorCode {
          font-size: 24px;
          font-family: Helvetica;
          font-weight: 400;
          color: #9e9e9f;
          margin: 16px 0 8px 0;
        }
        .colorName {
          font-size: 30px;
          font-family: PingFangSC;
          font-weight: 500;
          color: #595757;
          display: block;
        }
      }
      &:nth-of-type(4n) {
        margin: 37px 0;
      }
      &:hover {
        transition: all 0.3s ease-out;
        transform: scale(1.1);
        z-index: 9;
        cursor: pointer;
      }
      &:hover .inform {
        transition: all 1s ease-out;
        opacity: 1 !important;
      }
    }
  }
  .toomore {
    width: 466px;
    height: 66px;
    margin: 80px auto;
    background: #e7e7e7;
    font-size: 30px;
    font-family: FZLanTingHeiS-R-GB;
    font-weight: 400;
    color: #999999;
    line-height: 66px;
    text-align: center;
    cursor: pointer;
    -webkit-user-select: none;
    &.disabled {
      background: #f2f2f2;
      color: #ccc;
      cursor: not-allowed;
    }
    /deep/ .el-icon-loading {
      font-size: 30px!important;
      margin-right: 10px;
    }
  }
  /deep/ .el-dialog {
    width: 800px;
    position: absolute;
    top: 34px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    padding: 30px 30px;
    border-radius: 30px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      .box{
        position: relative;
        width: 100%;
        .header-icon {
          width: 100%;
        }
        .tit-pic{
          width: 100%;
          // height: 430px;
          object-fit: contain;
        }
        .link{
          position: absolute;
          width: 190px;
          height: 50px;
          margin-top: 50%;
          left: 50%;
          margin-left: -95px;
          cursor: pointer;
        }
        .content{
          margin-top: 42px;
        }
        .info{
          position: absolute;
          width: calc( (800 - 115) * 1px);
          height: 143px;
          margin-top: -77px;
          left: 15px;
          background: #FFFFFF;
          box-shadow: 0px 3px 18px 0px rgba(204,204,204,0.57);
          border-radius: 8px;
          padding-left: 19px;
          .info-name{
            padding-right: 19px;
            font-size: 26px;
            font-weight: 400;
            color: #333333;
            margin-top: 24px;
            text-overflow :ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
            white-space :nowrap; /*让文字不换行*/
            overflow : hidden;
            font-family: FZLanTingHeiS-DB-GB;
            text-align: left;
          }
          .line-s{
            width: 44px;
            height: 2px;
            background: #009245;
            margin-top: 14px;
          }
          .line-l{
            width: 100%;
            height: 1px;
            background: #E3E3E3;
          }
          .desc{
            min-height: 15px;
            line-height: 18px;
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            margin-top: 12px;
            padding-right: 19px;
            display: -webkit-box;
            overflow: hidden;
            -webkit-box-orient: vertical;
            line-clamp: 2;
            -webkit-line-clamp: 2;
            word-break: break-all;
            font-family: FZLanTingHeiS-DB-GB;
            text-align: left;
          }
        }
        .footer-icon {
          width: 100%;
          margin-top: -71px;
        }
      }
      /deep/ .content{
        p {
          font-size: 14px;
        }
        /deep/ img {
          max-width: 100%;
        }
        .text-huge{
          font-size: 25px;
        }
        .text-big{
          font-size: 19px;
        }
        .text-small{
          font-size: 12px;
        }
        .text-tiny{
          font-size: 10px;
        }
      }
      .closebtn {
        width: 70px;
        height: 70px;
        position: absolute;
        top: -25px;
        right: -220px;
        cursor: pointer;
      }
    }
  }
}
</style>